import React from 'react';
import { FormLabel, HStack, Wrap } from '@chakra-ui/react';
import { localise } from '../../../../../services/lang/lang';
import useAssignInspectorsFormField from './useAssignInspectorsFormField';
import { ErrorMessage } from '../../../../modules/ErrorMessage/ErrorMessage';
import RemovableChip from '../../../../modules/RemovableChip/RemovableChip';
export const AssignedInspectorsList = (props) => {
    const { onRemove, assignedInspector } = useAssignInspectorsFormField(props.onChange, props.assignee);
    const inspectorName = assignedInspector?.full_name;
    if (!inspectorName) {
        return React.createElement(ErrorMessage, { message: localise('ASSIGN_ERROR') });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FormLabel, null, localise('ASSIGNED_INSPECTORS')),
        React.createElement(HStack, { spacing: 4, mt: 2 },
            React.createElement(Wrap, { "data-testid": "assigned_inspector_list" },
                React.createElement(RemovableChip, { name: inspectorName, onRemove: onRemove })))));
};
